// extracted by mini-css-extract-plugin
module.exports = {"coming-wrapper":"comingsoon_coming-wrapper__1AVVC","coming-text":"comingsoon_coming-text__1Q4uK"};